import { ProductActiveStockItem } from '../../core/api/products/entities/product-active-stock-item.entity';
import { QuantityUnit } from '../../core/api/quantity-units/entities/quantity-unit.entity';

export function formatCamelCaseAsTitleCase(value: string): string {
  return value
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, char => char.toUpperCase())
    .trim();
}

export function formatCurrentStock(stockItems: ProductActiveStockItem[], quantityUnit: QuantityUnit): string {
  if (stockItems.length === 0) {
    return '-';
  }

  const amount = stockItems.reduce((acc, si) => acc + si.amount, 0);
  const amountOpened = stockItems.filter(si => si.openedAt !== null).reduce((acc, si) => acc + si.amount, 0);
  const quantityUnitName = amount === 1 ? quantityUnit.name : quantityUnit.namePlural;

  if (amountOpened === 0) {
    return `${amount} ${quantityUnitName}`;
  } else return `${amount} ${quantityUnitName} (${amountOpened} opened)`;
}

export function formatCurrentValue(stockItems: ProductActiveStockItem[]): number {
  return stockItems.reduce((acc, si) => acc + (si.price || 0) * si.amount, 0);
}

export function formatMinimumStockAmount(minimumStockAmount: number | null, quantityUnit: QuantityUnit): string {
  switch (minimumStockAmount) {
    case 0:
      return '-';
    case 1:
      return `1 ${quantityUnit.name}`;
    default:
      return `${minimumStockAmount} ${quantityUnit.namePlural}`;
  }
}
